import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../config/cabinet-environment';

export interface UserProfile {
  _id: string;
  email: string;
  firstname?: string;
  lastname?: string;
  phone_number?: string;
  company?: string;
  industry?: string;
  persona?: string;
  avatar_url?: string;
  role: string;
  permissions: string[];
  created_at: string;
  updated_at: string;
  owned_organization_id?: string;
  member_organization_id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly http = inject(HttpClient);
  public currentUserProfile?: UserProfile;
  public subscriptionsEnabled = environment.SUBSCRIPTIONS_ENABLED ?? false;

  getSettings() {
    return this.http.get<Record<string, unknown>>('/user/settings');
  }

  updateSettings(body: Record<string, unknown> | undefined) {
    return this.http.post('/user/settings', body);
  }

  getProfile() {
    return this.http.get<UserProfile>('/user/profile');
  }

  updateProfile(profileData: Partial<UserProfile>) {
    return this.http.post<UserProfile>('/user/profile', profileData);
  }

  refreshProfile() {
    return this.http.get<UserProfile>('/user/profile').pipe(
      tap((profile) => {
        this.currentUserProfile = {
          ...this.currentUserProfile,
          ...profile
        };
      })
    );
  }

  uploadAvatar(file: File) {
    const formData = new FormData();
    formData.append('avatar', file);
    return this.http.post<{ status: string; message: string; avatar_url: string }>('/user/avatar', formData);
  }

  deleteAvatar() {
    return this.http.post<{ status: string; message: string }>('/user/avatar/delete', {});
  }

  changePassword(currentPassword: string, newPassword: string) {
    return this.http.post<{ status: string; message: string }>('/user/change-password', {
      currentPassword,
      newPassword,
    });
  }

  deleteAccount(password: string) {
    return this.http.post<{ status: string; message: string }>('/user/delete-account', {
      password,
    });
  }

  clearUserData() {
    this.currentUserProfile = undefined;
  }
}
